import { render, staticRenderFns } from "./device_seven_top5.vue?vue&type=template&id=6d22a888&"
import script from "./device_seven_top5.vue?vue&type=script&lang=js&"
export * from "./device_seven_top5.vue?vue&type=script&lang=js&"
import style0 from "./device_seven_top5.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports